export const examTypes = ['B', 'A-AM', 'fiets'] as const;

export type ExamType = (typeof examTypes)[number];
